export default "__VITE_ASSET__05a2013e__$_?react__"